import { render, staticRenderFns } from "./roomCreateFeeList.vue?vue&type=template&id=bec9d13a&scoped=true"
import script from "./roomCreateFeeList.vue?vue&type=script&lang=js"
export * from "./roomCreateFeeList.vue?vue&type=script&lang=js"
import style0 from "./roomCreateFeeList.vue?vue&type=style&index=0&id=bec9d13a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec9d13a",
  null
  
)

export default component.exports